import React, { FC } from "react";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import { SvgIconProps } from "@mui/material";

export const SensorIcon: FC<SvgIconProps> = (props) => {
  return <FormatAlignLeftIcon sx={{ fontSize: 14 }} {...props} />;
};
